module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-four2.5b8a261.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-four2.png
// module id = jQdO
// module chunks = 0